// extracted by mini-css-extract-plugin
export default {"melodyVideo":"pK-z","isFullWidth":"qK-z","landingPageVideo":"rK-z","play":"sK-z","iframeVideo":"tK-z","playHidden":"uK-z","fullwidth":"vK-z"};